export default __webpack_public_path__ + "static/media/Lora-VariableFont_wght.86de6b10.ttf";